// 外部js、样式表加载器
const loadSingle = (url, doc, loadedUrls) => {
  console.log(loadedUrls)
  return new Promise((resolve, reject) => {
    let tag
    if (url.endsWith('.js')) {
      tag = doc.createElement('script')
      tag.type = 'application/javascript'
      tag.src = url
      tag.async = true
    } else {
      tag = doc.createElement('link')
      tag.rel = 'stylesheet'
      tag.href = url
      tag.async = true
    }

    tag.referrerPolicy = 'origin'
    tag.addEventListener('load', () => {
      resolve()
    })
    tag.addEventListener('error', event => {
      reject(event.reason)
    })
    if (doc.head) {
      doc.head.appendChild(tag)
    }
  })
}

async function load(urls, doc, async) {
  doc = doc || window.document

  const scriptSrcs = []
  let tags = [...doc.getElementsByTagName('script')]
  if (tags.length > 0) {
    tags.forEach(tag => {
      if (tag.hasAttribute('src')) {
        scriptSrcs.push(tag.getAttribute('src'))
      }
    })
  }
  const linkHrefs = []
  tags = [...doc.getElementsByTagName('link')]
  if (tags.length > 0) {
    tags.forEach(tag => {
      if (tag.hasAttribute('href')) {
        linkHrefs.push(tag.getAttribute('href'))
      }
    })
  }

  const loadedUrls = [...scriptSrcs, ...linkHrefs]

  if (urls instanceof Array) {
    if (async) {
      await aysncLoad(urls, doc, loadedUrls)
    } else {
      for (const url of urls) {
        await loadSingle(url, doc, loadedUrls)
      }
    }
  } else {
    await loadSingle(urls, doc, loadedUrls)
  }
}

const aysncLoad = (urls, doc, loadedUrls) => {
  return new Promise(resolve => {
    let total = urls.length
    for (const url of urls) {
      loadSingle(url, doc, loadedUrls).then(() => {
        total -= total
        if (total === 0) {
          resolve()
        }
      })
    }
  })
}

export default {
  load
}
